
/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Icon } from "@mui/material";
import { getUUIDFromKey } from 'utils/helpers';
import { VariantType } from 'notistack';
import { getQuiz } from 'services/quiz-services';
import { useLocation } from 'react-router-dom';
import { Howl } from 'howler'
import './styles.css'
import linearGradient from 'assets/theme/functions/linearGradient';
import Logo from '../../../assets/images/logo.svg'
import { useAppContext } from 'context/app-context';
import { QuizDto } from 'types';
import { QuestionValidator } from 'components/QuestionValidator';

function SeeCard(): JSX.Element {
  // const location = useLocation()
  // const state = location.state as CardType

  // useEffect(() => {
  //   setCategoryValue(state.category)
  //   setGradeValue(state.grade)
  //   setSubjectValue(state.subject)
  //   setTitle(state.title)
  //   setDescription(state.description)
  //   setAnswer(state.answer)

  // }, [state])
  const [subCategoryPk, setSubCategoryPk] = useState<string>('')
  const [pk, setPk] = useState<string>('')

  const { quizCards, handleMessage }: {
    quizCards: QuizDto[],
    setQuizCards: (quizzes: any[]) => void,
    handleMessage: (message: string, variant: VariantType) => void
  } = useAppContext()

  const location = useLocation()


  useEffect(() => {
    const list = location.pathname.split('/')
    const { [list.length - 1]: pathname } = list
    setPk(`QUIZ#${pathname}`)
  }, [location])

  useEffect(() => {
    if (quizCards.length && pk) {
      const editingQuizCard = quizCards.find(q => q.PK === pk)
      setGradeValue(editingQuizCard.category.grade)
      setSubjectValue(editingQuizCard.category.subject)
      setTitle(editingQuizCard.title)
      setDescription(editingQuizCard.description)
      setAnswer(editingQuizCard.answer)
      setCategoryValue(editingQuizCard.category.name)
      setSubCategoryPk(editingQuizCard.subcategory.subcategory)
    }
  }, [pk, quizCards])

  const [descriptionAudioFile, setDescriptionAudioFile] = useState('')
  const [descriptionImageFile, setDescriptionImageFile] = useState('')
  const [answerAudioFile, setAnswerAudioFile] = useState('')
  const [answerImageFile, setAnswerImageFile] = useState('')

  useEffect(() => {
    (async () => {
      const quiz = await getQuiz(getUUIDFromKey(subCategoryPk), getUUIDFromKey(pk))
      setDescriptionAudioFile(quiz.descriptionAudio)
      setDescriptionImageFile(quiz.descriptionImage)
      setAnswerAudioFile(quiz.answerAudio)
      setAnswerImageFile(quiz.answerImage)
    })()

  }, [subCategoryPk, pk])



  const [subjectValue, setSubjectValue] = useState<string | null>(null);
  const [gradeValue, setGradeValue] = useState<string | null>(null);
  const [categoryValue, setCategoryValue] = useState<string>('')
  const [description, setDescription] = useState<string>('')
  const [title, setTitle] = useState<string>('')
  const [answer, setAnswer] = useState<string>('')
  const [playingDescriptionSound, setPlayingDescriptionSound] = useState(false);
  const [playingAnswerSound, setPlayingAnswerSound] = useState(false);
  const [descriptionSound, setDescriptionSound] = useState<Howl>({} as Howl)
  const [answerSound, setAnswerSound] = useState<Howl>({} as Howl)
  const [seeAnswer, setSeeAnswer] = useState<boolean>(false)
  const [seeAnimation, setSeeAnimation] = useState(true)

  useEffect(() => {
    if (descriptionAudioFile)
      setDescriptionSound(new Howl({
        src: descriptionAudioFile,
        html5: true,
        onend: function () {
          setPlayingDescriptionSound(false)
        },
      }))

  }, [descriptionAudioFile])

  useEffect(() => {
    if (answerAudioFile) {
      setAnswerSound(new Howl({
        src: answerAudioFile,
        html5: true,
        onend: function () {
          setPlayingAnswerSound(false)
        },
      }))
    }
  }, [answerAudioFile])


  const handleDescriptionSound = (): void => {
    setPlayingDescriptionSound(!playingDescriptionSound)
    try {
      if (!playingDescriptionSound) {
        descriptionSound.play()
      } else {
        descriptionSound.stop()
      }
    } catch (error) {
      handleMessage("Der er ingen lyd til denne quiz", 'info')
    }
  }

  const handleAnswerSound = (): void => {
    setPlayingAnswerSound(!playingAnswerSound)
    try {
      if (!playingAnswerSound) {
        answerSound.play()
      } else {
        answerSound.stop()
      }
    } catch (error) {
      handleMessage("Der er ingen lyd til denne quiz", 'info')
    }
  }


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card >
        <MDBox p={3} lineHeight={1}>
          <MDTypography variant="h5" fontWeight="medium">
            Card {title}
          </MDTypography>
          <Grid container justifyContent={'center'}>
            <Grid item sm={12} lg={6} >
              <MDBox
                justifyContent='space-between'
                alignItems='center'
                display='flex'
                flexDirection='column'>
                <MDBox mt={1} px={2} width={"100%"}>
                  <MDBox mt={1} px={2}
                    display='flex'
                    flexDirection='column'
                    alignItems='center'
                  >
                    <ul style={{ paddingLeft: 20 }}>
                      <li><MDTypography textTransform="capitalize">grade: {gradeValue}</MDTypography></li>
                      <li><MDTypography textTransform="capitalize">subject: {subjectValue}</MDTypography></li>
                      <li><MDTypography textTransform="capitalize">category: {categoryValue}</MDTypography></li>
                    </ul>
                    <MDBox mt={1}>
                      <MDBox
                        marginRight='auto'
                        marginLeft='auto'
                        maxWidth={480}
                        width="calc(100vw - 68px)"
                        bgColor={linearGradient('#7030A0', '#00B0F0', 0)}
                        py={3}
                        px={3}
                        borderRadius='5rem'
                        border={`.5em solid white`}
                        boxShadow='0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important'
                      >
                        <MDTypography variant='h3' color='white' textAlign='center' fontWeight='bold'>{title}</MDTypography>
                        <div
                          style={{
                            paddingTop: 20,
                            paddingBottom: 20,
                            width: '100%',
                            color: 'white',
                            display: 'flex',
                            marginBottom: 15,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            paddingLeft: 15,
                            paddingRight: 15,
                            textAlign: 'start',
                            // border: '1px solid #ccc'
                          }}
                          dangerouslySetInnerHTML={
                            { __html: description as string }
                          } />
                        {descriptionImageFile &&
                          <>
                            {/* <MDTypography color="white" fontWeight='bold'>Image:</MDTypography> */}
                            <Zoom>
                              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
                                <img
                                  style={{
                                    maxWidth: 300,
                                    maxHeight: 300,
                                    width: "auto"
                                  }}
                                  alt="quiz img"
                                  src={descriptionImageFile}
                                />
                              </div>
                            </Zoom>
                          </>}
                        {descriptionAudioFile && <>
                          {/* <MDTypography color="white" fontWeight='bold'>Audio:</MDTypography> */}
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <MDButton onClick={() => handleDescriptionSound()} iconOnly><Icon 
                            id="icon-large-font-play" fontSize='large'>{playingDescriptionSound ? 'stop' : 'play_arrow'}</Icon></MDButton>
                          </div>
                        </>}
                        <div style={{ display: 'block', height: 250 }}>
                          {!seeAnswer ?
                            (
                              <div>
                                <div className="button" onClick={() => setSeeAnswer(true)} style={{ position: 'relative' }}>

                                  <MDTypography className='text' variant="h5" fontWeight="medium">
                                    <span style={{ color: '#FFFFFF' }}>Svar</span>
                                  </MDTypography>

                                </div>
                              </div>

                            )
                            :
                            seeAnimation ? <QuestionValidator setSeeAnimation={setSeeAnimation} correct={true} /> :
                              (
                                <>
                                  <div style={{
                                    height: "80%",
                                    marginBottom: 15,
                                    marginTop: 15,
                                    // border: '1px solid #ccc',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    flexWrap: 'wrap'
                                  }}>
                                    <div
                                      style={{
                                        height: 'fit-content',
                                        marginBottom: 10,
                                        width: '100%',
                                        color: 'white',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        textAlign: 'start',
                                      }}
                                      dangerouslySetInnerHTML={
                                        { __html: answer }
                                      } />
                                    <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                      {answerImageFile && <Zoom >
                                        <img
                                          height='30%'
                                          style={{ maxWidth: 200, maxHeight: 145, width: "auto" }}
                                          alt="quiz img"
                                          src={answerImageFile}
                                        />
                                      </Zoom>}
                                      {answerAudioFile && <>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                          <MDButton onClick={() => handleAnswerSound()} iconOnly><Icon id="icon-large-font-answer" fontSize='large'>{playingAnswerSound ? 'stop' : 'play_arrow'}</Icon></MDButton>
                                        </div>
                                      </>}
                                    </div>
                                  </div>
                                </>
                              )}
                        </div>
                        <MDBox display={'flex'} justifyContent={'center'}><img src={Logo} alt='logo' /></MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox >
      </Card >
    </DashboardLayout >
  );
}


export default SeeCard;
